import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * Asynchronously loads the component for OrganizationDetailsPage
 *
 */
import Loadable from 'react-loadable';
import PageLoader from '@project/components/Loaders/PageLoader';
//Below block is not used
// export default Loadable({
//   loader: () =>
//     import(
//      /* webpackChunkName: 'OrganizationDetailsPage' */ './remove-this-not-used-index'
//     ),
//   loading: props => {
//     if (props.error) {
//       console.error(props.error);
//     }
//     return <PageLoader />;
//   },
// });
export var InviteUserPage = Loadable({
    loader: function () {
        return import(/* webpackChunkName: 'InviteUserPage' */ './InviteUserPage');
    },
    loading: function (props) {
        if (props.error) {
            console.error(props.error);
        }
        return _jsx(PageLoader, {});
    },
});
